export default {
  invoiceList: {
    items: [], _links: {}, _meta: {}
  }
}
